import { ComponentType } from "react";

import { Autocomplete, AutocompleteProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/input/autocomplete";

export const CustomAutocomplete: ComponentType<AutocompleteProps> = function CustomAutocomplete(props) {
	return <Autocomplete {...props} openOnFocus={props.openOnFocus === true} />;
};
